module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "top_content",
    attrs: {
      "element-loading-text": _vm.$t('common.loading')
    }
  }, [_c('sidebar', {
    attrs: {
      "shop": _vm.shop
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "user_wrapper"
  }, [_c('div', {
    staticClass: "user_name"
  }, [_c('span', [_vm._v(_vm._s(_vm.type))]), _vm._v("\n          " + _vm._s(_vm.role.isCashier ? ((_vm.shop.shopname) + "  " + ((_vm.shop.opinfo || {}).opname) + "(" + ((_vm.shop.opinfo || {}).opuid) + ")") : ("" + (_vm.shop.shopname))) + "\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "user_operation"
  }, [_c('i', {
    staticClass: "icon-ic_logout"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('common.logout')))])])])])]), _vm._v(" "), _c('router-view', {
    attrs: {
      "shop": _vm.shop
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6fa25648"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/main/main.vue
// module id = 923
// module chunks = 0